import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import { AdminMedicineModel } from "../../models/medicine/";
import { TabView, TabPanel } from 'primereact/tabview';
import ManufacturerService from '../../services/manufacturerService';
import MedicineTabBasicInfo from './medicineTabBasicInfo';
import MedicineTabOverview from './medicineTabOverview';
import MedicineTabInteractionsContent from './medicineTabInteractionsContent';
import MedicineTabDosage from './medicineTabDosage';
import MedicineTabSideEffects from './medicineTabSideEffects';
import MedicineTabProfessional from './medicineTabProfessional';
import MedicineTabLeaflet from './medicineTabLeaflet';
import MedicineTabPregnancy from './medicineTabPregnancy';
import MedicineTabSafetyData from './medicineTabSafetyData';
import ActiveingredientListDialog from './activeIngredientListDialog';
import InactiveingredientListDialog from './inactiveIngredientListDialog';
import { ActiveIngredientForAdminMedicineModel } from "../../models/activeIngredient";
import { InactiveIngredientForAdminMedicineModel } from "../../models/inactiveIngredient";
import { FileModel } from "../../models/fileModel";
import { ImageModel } from "../../models/imageModel";
import { AdminMedicineSpecificationModel } from '../../models/medicine/adminMedicineSpecificationModel';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { OverlayPanel } from 'primereact/overlaypanel';
import { PregnancyAndBreastfeedingModel } from '../../models/medicine/pregnancyAndBreastfeedingModel';
import { DriveAndMachineModel } from '../../models/medicine/driveAndMachineModel';
import { IngredientSideEffectReactionModel, IngredientSideEffectModel } from "../../models/sideEffect";
import SideEffectReactionAddEditDialog from './sideEffectReactionAddEditDialog';
import { DosageContentModel, DosageLevelModel } from "../../models/dosage";
import DosageLevelAddEditDialog from './dosageLevelAddEditDialog';
import { InputSwitch } from 'primereact/inputswitch';
import { SafetyDataModel } from '../../models/medicine/safetyDataModel';
import Translate from '../../common/functions/translate';
import { ATCCodeModel } from "../../models/atcCode";
import AtcCodeListDialog from './atcCodeListDialog';
import MedicineTabDriveMachine from './medicineTabDriveMachine';
import Language from '../../common/components/language/language';
import { Lang } from '../../common/enums';
import { SafetyDataContentModel } from '../../models/medicine/safetyDataContentModel';
import { DriveAndMachineContentModel } from '../../models/medicine/driveAndMachineContentModel';
import { PregnancyAndBreastfeedingContentModel } from '../../models/medicine/pregnancyAndBreastfeedingContentModel';
import { IngredientSideEffectContentModel } from '../../models/sideEffect/ingredientSideEffectContentModel';
import { DosageContentContentModel } from '../../models/dosage/dosageContentContentModel';
import { MedicineInteractionContentModel } from "../../models/medicine/medicineInteractionContentModel";
import ManufactorerListDialogComponent from './manufacturerListDialog';
import { ManufacturerAdminModel } from '../../models/manufacturer';

interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	currentMedicine: AdminMedicineModel
}

interface IState {
	city: any,
	manufaturers: any,
	medicine: AdminMedicineModel,
	validationMessage: string,
	isVisibleActiveIngredientDialog: boolean,
	isVisibleInactiveIngredientDialog: boolean,
	isVisibleSideEffectReactionAddEditDialog: boolean;
	imageUrl: string;
	currentSideEffectReaction: IngredientSideEffectReactionModel;
	currentDosageLevel: DosageLevelModel;
	isVisibleDosageLevelAddEditDialog: boolean;
	isWithSideEffects: boolean;
	isWithDosageContent: boolean;
	isWithPregnancy: boolean;
	isAnatomicalSystemDropdownDisabled: boolean;
	isWithSafetyData: boolean;
	isVisibleATCCodeListDialog: boolean;
	isWithDriveAndMachine: boolean;
	isWithInteractionContent: boolean;
	selectedLangId: number;
	activeIndex: number;
	selectedManufacturerName: string;
	selectedAuthorisationHolderName: string;
	isVisibleManufacturerDialog: boolean;
	isVisibleAuthorisationHolderDialog: boolean;
	isManufacturer: boolean;
	selectedManufacturer: ManufacturerAdminModel
}

class MedicineAddEditDialog extends React.Component<IProps, IState> {

	manufacturerService = new ManufacturerService();
	op: any;

	constructor(props: IProps) {
		super(props);

		if (!props.currentMedicine.manufacturerId) {
			props.currentMedicine.manufacturerId = -1;
		}

		if (!props.currentMedicine.leaflets) {
			props.currentMedicine.leaflets = new Array<FileModel>(0);
		}

		if (!props.currentMedicine.specification) {
			props.currentMedicine.specification = new AdminMedicineSpecificationModel();
		}

		if (!props.currentMedicine.specification.images) {
			props.currentMedicine.specification.images = new Array<ImageModel>(0);
		}

		if (!props.currentMedicine.specification.roaTypeId) {
			props.currentMedicine.specification.roaTypeId = -1;
		}

		if (!props.currentMedicine.pregnancyAndBreastfeeding) {
			props.currentMedicine.pregnancyAndBreastfeeding = new PregnancyAndBreastfeedingModel();
		}

		if (!props.currentMedicine.driveAndMachine) {
			props.currentMedicine.driveAndMachine = new DriveAndMachineModel();
		}

		if (!props.currentMedicine.sideEffect) {
			props.currentMedicine.sideEffect = new IngredientSideEffectModel();
		}

		if (!props.currentMedicine.sideEffect.ingredientSideEffectReactions) {
			props.currentMedicine.sideEffect.ingredientSideEffectReactions = new Array<IngredientSideEffectReactionModel>(0);
		}

		if (!props.currentMedicine.dosageContent) {
			props.currentMedicine.dosageContent = new DosageContentModel();
		}

		if (!props.currentMedicine.dosageContent.dosageLevels) {
			props.currentMedicine.dosageContent.dosageLevels = new Array<DosageLevelModel>(0);
		}

		if (!props.currentMedicine.safetyData) {
			props.currentMedicine.safetyData = new SafetyDataModel();
		}

		if (!props.currentMedicine.atcCode) {
			props.currentMedicine.atcCode = new ATCCodeModel();
		}

		if (!props.currentMedicine.medicineInteractionContents) {
			props.currentMedicine.medicineInteractionContents = new Array<MedicineInteractionContentModel>(0);
		}

		this.state = {
			manufaturers: null,
			city: null,
			medicine: props.currentMedicine,
			validationMessage: '',
			isVisibleActiveIngredientDialog: false,
			isVisibleInactiveIngredientDialog: false,
			isVisibleSideEffectReactionAddEditDialog: false,
			imageUrl: '',
			currentSideEffectReaction: new IngredientSideEffectReactionModel(),
			currentDosageLevel: new DosageLevelModel(),
			isVisibleDosageLevelAddEditDialog: false,
			isWithSideEffects: props.currentMedicine.isWithSideEffects,
			isWithDosageContent: props.currentMedicine.isWithDosageContent,
			isWithPregnancy: props.currentMedicine.isWithPregnancy,
			isAnatomicalSystemDropdownDisabled: false,
			isWithSafetyData: props.currentMedicine.isWithSafetyData,
			isWithInteractionContent: props.currentMedicine.isWithInteractionContent,
			isVisibleATCCodeListDialog: false,
			isWithDriveAndMachine: props.currentMedicine.isWithDriveAndMachine,
			selectedLangId: Lang.bg,
			activeIndex: TabIndexes.BasicInfo,
			selectedManufacturerName: '',
			selectedAuthorisationHolderName: '',
			isVisibleManufacturerDialog: false,
			isVisibleAuthorisationHolderDialog: false,
			isManufacturer: false,
			selectedManufacturer: new ManufacturerAdminModel()
		};
	}

	componentDidMount() {
		if (this.state.medicine.authorisationHolderName && this.state.medicine.authorisationHolderName.trim() != '') {
			this.setState({ selectedAuthorisationHolderName: this.state.medicine.authorisationHolderName });
		}

		if (this.state.medicine.manufacturerName && this.state.medicine.manufacturerName.trim() != '') {
			this.setState({ selectedManufacturerName: this.state.medicine.manufacturerName });
		}
	}

	handleSetIsWithPregnancy = (e) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		medicine.isWithPregnancy = e.value;
		const pregnancy: PregnancyAndBreastfeedingModel = { ...medicine.pregnancyAndBreastfeeding };
		let contentList = new Array<PregnancyAndBreastfeedingContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new PregnancyAndBreastfeedingContentModel();
			content.langId = parseInt(Lang[k]);
			content.pregnancyContent = '';
			content.breastfeedingContent = '';
			contentList.push(content);
		});

		pregnancy.pregnancyAndBreastfeedingContent = contentList;
		medicine.pregnancyAndBreastfeeding = pregnancy;

		this.setState({
			isWithPregnancy: e.value,
			medicine: medicine
		});
	}

	handleSetIsWithInteractionContent = (e) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		medicine.isWithInteractionContent = e.value;
		let interactions = new Array<MedicineInteractionContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new MedicineInteractionContentModel();
			content.langId = parseInt(Lang[k]);
			content.description = '';
			interactions.push(content);
		});

		medicine.medicineInteractionContents = interactions;

		this.setState({
			isWithInteractionContent: e.value,
			medicine: medicine
		});
	}

	handleSetIsWithDriveAndMachine = (e) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const machine: DriveAndMachineModel = { ...medicine.driveAndMachine };
		medicine.isWithDriveAndMachine = e.value;
		let contentList = new Array<DriveAndMachineContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new DriveAndMachineContentModel();
			content.langId = parseInt(Lang[k]);
			content.driveDescription = '';
			content.machineDescription = '';
			contentList.push(content);
		});

		machine.driveAndMachineContent = contentList;
		medicine.driveAndMachine = machine;

		this.setState({
			isWithDriveAndMachine: e.value,
			medicine: medicine
		});
	}

	handleSetIsWithSafetyData = (e) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const safetyData: SafetyDataModel = { ...medicine.safetyData };
		medicine.isWithSafetyData = e.value;
		let contentList = new Array<SafetyDataContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new SafetyDataContentModel();
			content.langId = parseInt(Lang[k]);
			content.productDisposal = '';
			content.productHandling = '';
			content.shelfLife = '';
			content.storagePlace = '';
			content.storagePrecautions = '';
			contentList.push(content);
		});

		safetyData.safetyDataContent = contentList;
		medicine.safetyData = safetyData;

		this.setState({
			isWithSafetyData: e.value,
			medicine: medicine
		});
	}

	handleSetIsWithDosageContent = (e) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const dosageContent: DosageContentModel = { ...medicine.dosageContent }
		medicine.isWithDosageContent = e.value;
		let contentList = new Array<DosageContentContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new DosageContentContentModel();
			content.langId = parseInt(Lang[k]);
			content.summary = '';
			content.overdoseDescription = '';
			content.professionalDescription = '';
			content.doseAdjustments = '';
			content.precautions = '';
			content.otherComments = '';
			content.otherInformation = '';
			contentList.push(content);
		});

		dosageContent.dosageContentContent = contentList;
		medicine.dosageContent = dosageContent;

		this.setState({
			isWithDosageContent: e.value,
			medicine: medicine
		});
	}

	handleSetIsWithSideEffects = (e) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const sideEffects: IngredientSideEffectModel = { ...medicine.sideEffect };
		medicine.isWithSideEffects = e.value;
		let contentList = new Array<IngredientSideEffectContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new IngredientSideEffectContentModel();
			content.langId = parseInt(Lang[k]);
			content.consumerDescription = '';
			content.otherInformation = '';
			content.overdoseDescription = '';
			content.professionalDescription = '';
			content.summary = '';
			contentList.push(content);
		});

		sideEffects.ingredientSideEffectContent = contentList;
		medicine.sideEffect = sideEffects;

		this.setState({
			isWithSideEffects: e.value,
			medicine: medicine
		});
	}

	handleChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		medicine[key] = value;
		this.setState({ medicine: { ...medicine } });
	};

	handleContentChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		let content = medicine.medicineContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ medicine: { ...medicine } });
	};

	handleOverviewContentChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		let content = medicine.medicineOverviewContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ medicine: { ...medicine } });
	};

	handleInteractionsContentChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		let content = medicine.medicineInteractionContents.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ medicine: { ...medicine } });
	};

	handleSpecificationChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		medicine.specification[key] = value;
		this.setState({ medicine: { ...medicine } });
	};

	handleSpecificationContentChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const specification: AdminMedicineSpecificationModel = { ...medicine.specification }
		let content = specification.medicineSpecificationContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ medicine: { ...medicine } });
	};

	handlePregnancyChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const pregnancy: PregnancyAndBreastfeedingModel = { ...medicine.pregnancyAndBreastfeeding };
		let content = pregnancy.pregnancyAndBreastfeedingContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ medicine: { ...medicine } });

	};

	handleDriveMachineChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const machine: DriveAndMachineModel = { ...medicine.driveAndMachine };
		let content = machine.driveAndMachineContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ medicine: { ...medicine } });
	};

	handleSafetyDataChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const safetyData: SafetyDataModel = { ...medicine.safetyData };
		let content = safetyData.safetyDataContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ medicine: { ...medicine } });
	};

	isValidAddEditForm() {
		let message = '';

		if (!this.state.medicine.medicineContent.some(r => r.brandName != null)) {
			message += "Please enter 'BG name' or 'En name'.<br />";
		}

		// if (!this.state.currentMedicine.medicineNumber || this.state.currentMedicine.medicineNumber.trim() == '') {
		// 	message += 'Please enter number.<br />';
		// }

		// if (!this.state.currentMedicine.shortDescription || this.state.currentMedicine.shortDescription.trim() == '') {
		// 	message += 'Please enter short description.<br />';
		// }

		// if (!this.state.currentMedicine.medicineDescription || this.state.currentMedicine.medicineDescription.trim() == '') {
		// 	message += 'Please enter description.<br />';
		// }

		this.setState({
			validationMessage: message
		});

		return message == '';
	}

	handleSaveButton = (event, close) => {
		event.preventDefault();

		if (!this.isValidAddEditForm()) return;

		const medicine = this.state.medicine;

		if (medicine.manufacturerId && medicine.manufacturerId < 0) {
			medicine.manufacturerId = undefined;
		}

		if (medicine.authorisationHolderId && medicine.authorisationHolderId < 0) {
			medicine.authorisationHolderId = undefined;
		}

		if (medicine.specification && medicine.specification.roaTypeId == -1) {
			medicine.specification.roaTypeId = undefined;
		}

		if (medicine.specification && medicine.specification.firstAuthorizationDate) {
			medicine.specification.firstAuthorizationDate = HelperFunctions.fomatDateAsString(new Date(medicine.specification.firstAuthorizationDate))
		}

		if (medicine.specification && medicine.specification.lastAuthorizationDate) {
			medicine.specification.lastAuthorizationDate = HelperFunctions.fomatDateAsString(new Date(medicine.specification.lastAuthorizationDate))
		}

		this.props.saveClick(medicine, close);
	}

	handleCanselButton = () => {
		this.props.cancelClick();
	}

	// ActiveIngredients

	handleActiveIngredientCancelButton = () => {
		this.setState({
			isVisibleActiveIngredientDialog: false
		})
	};

	handleSetIsAnatomicalSystemDropdownDisabled = (show) => {
		this.setState({
			isAnatomicalSystemDropdownDisabled: show
		})
	}


	handleSetIsVisibleActiveIngredientDialog = (show) => {
		this.setState({
			isVisibleActiveIngredientDialog: show
		})
	}

	handleActiveingredientAddButton = (selectedActiveIngredients: Array<ActiveIngredientForAdminMedicineModel>) => {
		let medicine = this.state.medicine;

		selectedActiveIngredients.map(a => {
			if (!medicine.activeIngredients.some(f => f.activeIngredientId == a.activeIngredientId)) {
				medicine.activeIngredients.push(a);
			}
		});

		this.setState({
			medicine: { ...medicine },
			isVisibleActiveIngredientDialog: false
		});
	};

	removeActiveIngredientClick(activeIngredientId) {
		const medicine = this.state.medicine;
		const activeIngredientIndex = medicine.activeIngredients.findIndex(a => a.activeIngredientId == activeIngredientId);
		medicine.activeIngredients.splice(activeIngredientIndex, 1);
		this.setState({
			medicine: medicine
		})
	}

	// InactiveIngredients

	handleInactiveIngredientCancelButton = () => {
		this.setState({
			isVisibleInactiveIngredientDialog: false
		})
	};

	handleSetIsVisibleInactiveIngredientDialog = (show) => {
		this.setState({
			isVisibleInactiveIngredientDialog: show
		})
	}

	handleInactiveingredientAddButton = (selectedInactiveIngredients: Array<InactiveIngredientForAdminMedicineModel>) => {
		let medicine = this.state.medicine;

		selectedInactiveIngredients.map(a => {
			if (!medicine.inactiveIngredients.some(f => f.inactiveIngredientId == a.inactiveIngredientId)) {
				medicine.inactiveIngredients.push(a);
			}
		});

		this.setState({
			medicine: { ...medicine },
			isVisibleInactiveIngredientDialog: false
		});
	};

	removeInactiveIngredientClick(inactiveIngredientId) {
		const medicine = this.state.medicine;
		const inactiveIngredientIndex = medicine.inactiveIngredients.findIndex(a => a.inactiveIngredientId == inactiveIngredientId);
		medicine.inactiveIngredients.splice(inactiveIngredientIndex, 1);
		this.setState({
			medicine: medicine
		})
	}

	// Specification

	handleAddImage = (imageModel: ImageModel) => {
		if (imageModel) {
			let medicine = this.state.medicine;
			medicine.specification.images.push(imageModel);
			this.setState({
				medicine: { ...medicine }
			});
		}
	}

	handleRemoveImage = (imageModel: ImageModel) => {
		if (imageModel) {
			let file = imageModel;
			let medicine = this.state.medicine;
			let index;

			if (imageModel.imageId) {
				index = medicine.specification.images.findIndex(f => f.imageId == imageModel.imageId);
			} else {
				index = medicine.specification.images.findIndex(f => f.imageName == imageModel.imageName);
			}

			medicine.specification.images.splice(index, 1);
			this.setState({
				medicine: medicine
			});
		}
	}

	// Leaflets

	handleAddLeaflet = (fileModel: FileModel) => {
		if (fileModel) {
			let medicine = this.state.medicine;
			medicine.leaflets.push(fileModel);
			this.setState({
				medicine: { ...medicine }
			});
		}
	}

	handleRemoveLeaflet = (fileModel: FileModel) => {
		if (fileModel) {
			let medicine = this.state.medicine;
			let index;

			if (fileModel.fileId) {
				index = medicine.leaflets.findIndex(f => f.fileId == fileModel.fileId);
			} else {
				index = medicine.leaflets.findIndex(f => f.fileName == fileModel.fileName);
			}

			medicine.leaflets.splice(index, 1);
			this.setState({
				medicine: medicine
			});
		}
	}

	handleLeafletTypeChange = (fileModel: FileModel, value) => {
		if (fileModel) {
			let medicine = this.state.medicine;
			let index;

			if (fileModel.fileId) {
				index = medicine.leaflets.findIndex(f => f.fileId == fileModel.fileId);
			} else {
				index = medicine.leaflets.findIndex(f => f.fileName == fileModel.fileName);
			}
			medicine.leaflets[index].medicineLeafletTypeId = value;
			this.setState({
				medicine: medicine
			});
		}
	}

	handleToggleImage = (e, imageUrl) => {
		this.setState({
			imageUrl: imageUrl
		})
		this.op.toggle(e);
	}

	handleSideEffectChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const currentSideEffect: IngredientSideEffectModel = { ...medicine.sideEffect };
		let content = currentSideEffect.ingredientSideEffectContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}

		medicine.sideEffect = currentSideEffect;
		this.setState({ medicine: { ...medicine } });
	};

	handleCurrentSideEffectReaction = (currentSideEffectReaction: IngredientSideEffectReactionModel) => {
		this.setState({ currentSideEffectReaction: { ...currentSideEffectReaction } });
	}

	handleSetIsVisibleSideEffectReactionDialog = (show) => {
		this.setState({
			isVisibleSideEffectReactionAddEditDialog: show
		})
	}

	removeSideEffectReactionClick(ingredientSideEffectReactionId) {
		const medicine = this.state.medicine;
		const activeIndex = medicine.sideEffect.ingredientSideEffectReactions.findIndex(a =>
			a.ingredientSideEffectReactionId == ingredientSideEffectReactionId);

		medicine.sideEffect.ingredientSideEffectReactions.splice(activeIndex, 1);
		this.setState({
			medicine: medicine
		})
	}


	handleSideEffectReactionAddButton = (currentSideEffectReaction: IngredientSideEffectReactionModel) => {
		if (this.state.medicine.sideEffect.ingredientSideEffectReactions
			.some(f => f.ingredientSideEffectReactionId === currentSideEffectReaction.ingredientSideEffectReactionId)) {

			let medicine = this.state.medicine;
			let activeIndex = medicine.sideEffect.ingredientSideEffectReactions
				.findIndex(a => a.ingredientSideEffectReactionId === currentSideEffectReaction.ingredientSideEffectReactionId);

			medicine.sideEffect.ingredientSideEffectReactions[activeIndex] = currentSideEffectReaction;
			this.setState({ medicine: { ...medicine } });
		} else {

			let medicine = this.state.medicine;
			medicine.sideEffect.ingredientSideEffectReactions.push(currentSideEffectReaction);
			this.setState({ medicine: { ...medicine } });
		};

		this.handleSetIsVisibleSideEffectReactionDialog(false);
	}

	handleSideEffectCancelButton = () => {
		this.handleSetIsVisibleSideEffectReactionDialog(false);
	};

	handleDosageContentChange = (key, value) => {
		const medicine: AdminMedicineModel = { ...this.state.medicine };
		const currentDosageContent: DosageContentModel = { ...medicine.dosageContent };
		let content = currentDosageContent.dosageContentContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}

		medicine.dosageContent = currentDosageContent;
		this.setState({ medicine: { ...medicine } });
	};


	handleCurrentDosageLevel = (currentDosageLevel: DosageLevelModel) => {
		this.setState({ currentDosageLevel: { ...currentDosageLevel } });
	}

	handleSetIsVisibleDosageLevelAddEditDialog = (show) => {
		this.setState({
			isVisibleDosageLevelAddEditDialog: show
		})
	}

	handleDosageLevelCancelButton = () => {
		this.handleSetIsVisibleDosageLevelAddEditDialog(false);
	};

	removeDosageLevelClick(dosageLevelId) {
		const medicine = this.state.medicine;
		const activeIndex = medicine.dosageContent.dosageLevels.findIndex(a =>
			a.dosageLevelId === dosageLevelId);

		medicine.dosageContent.dosageLevels.splice(activeIndex, 1);
		this.setState({
			medicine: medicine
		})
	}

	handleDosageLevelAddButton = (currentDosageLevel: DosageLevelModel) => {
		if (this.state.medicine.dosageContent.dosageLevels
			.some(f => f.dosageLevelId === currentDosageLevel.dosageLevelId)) {

			const activeIndex = this.state.medicine.dosageContent.dosageLevels
				.findIndex(a => a.dosageLevelId === currentDosageLevel.dosageLevelId);

			this.state.medicine.dosageContent.dosageLevels[activeIndex] = currentDosageLevel;
		} else {
			this.state.medicine.dosageContent.dosageLevels.push(currentDosageLevel);
		};

		this.handleSetIsVisibleDosageLevelAddEditDialog(false);
	}

	handleATCCodeCancelButton = () => {
		this.handleSetIsVisibleATCCodeListDialog(false);
	};

	handleSetIsVisibleATCCodeListDialog = (show) => {
		this.setState({
			isVisibleATCCodeListDialog: show
		})
	}

	handleATCCodeRemoveClick = () => {
		let medicine = { ...this.state.medicine };
		medicine.atcCode = undefined;

		this.setState({
			medicine: medicine
		});
	}

	handleATCCodeAddButton = (currentATCCode: ATCCodeModel) => {
		let medicine = { ...this.state.medicine }
		medicine.atcCode = currentATCCode;
		this.setState({ medicine: medicine });
		this.handleSetIsVisibleATCCodeListDialog(false);
	}

	handleQuantityChange = (activeIngredient: ActiveIngredientForAdminMedicineModel, value, key) => {
		const medicine = { ...this.state.medicine };
		let activeIngredients = [...medicine.activeIngredients];
		const aIndex = activeIngredients.indexOf(activeIngredient);
		const activeIngredientV: ActiveIngredientForAdminMedicineModel = { ...activeIngredients[aIndex] };
		activeIngredientV[key] = value;
		activeIngredients[aIndex] = { ...activeIngredientV };
		medicine.activeIngredients = [...activeIngredients];
		this.setState({ medicine: { ...medicine } });
	}

	onLangChange = (lang) => {
		this.setState({ selectedLangId: lang }, this.checkIndexes);
	}

	checkIndexes = () => {
		const index = this.state.activeIndex;
		if (index == TabIndexes.Driving || index == TabIndexes.Pregnancy || index == TabIndexes.Dosage ||
			index == TabIndexes.Overview || index == TabIndexes.SideEffect || index == TabIndexes.Professional) {
			setTimeout(() => {
				this.setState({ activeIndex: TabIndexes.NonExisting }, () => {
					this.setState({ activeIndex: index })
				});
			});
		}
	}

	getSafetyDataValueContent = (key) => {

		if (!this.state.medicine.safetyData.safetyDataContent) {
			this.state.medicine.safetyData.safetyDataContent = new Array<SafetyDataContentModel>();
		}
		let content = this.state.medicine.safetyData.safetyDataContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getDriveAndMachineValueContent = (key) => {
		if (!this.state.medicine.driveAndMachine.driveAndMachineContent) {
			this.state.medicine.driveAndMachine.driveAndMachineContent = new Array<DriveAndMachineContentModel>();
		}
		let content = this.state.medicine.driveAndMachine.driveAndMachineContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getPregnancyValueContent = (key) => {
		if (!this.state.medicine.pregnancyAndBreastfeeding.pregnancyAndBreastfeedingContent) {
			this.state.medicine.pregnancyAndBreastfeeding.pregnancyAndBreastfeedingContent = new Array<PregnancyAndBreastfeedingContentModel>();
		}
		let content = this.state.medicine.pregnancyAndBreastfeeding.pregnancyAndBreastfeedingContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getSideEffectValueContent = (key) => {
		let content = this.state.medicine.sideEffect.ingredientSideEffectContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getDosageContentValueContent = (key) => {
		let content = this.state.medicine.dosageContent.dosageContentContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getMedicineValueContent = (key) => {
		let content = this.state.medicine.medicineContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getMedicineOverviewValueContent = (key) => {
		let content = this.state.medicine.medicineOverviewContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getMedicineInteractionValueContent = (key) => {
		let content = this.state.medicine.medicineInteractionContents.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getSpecificationValueContent = (key) => {
		let content = this.state.medicine.specification.medicineSpecificationContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	handleSetIsVisibleManufactorerListDialog = (show) => {
		this.setState({
			isVisibleManufacturerDialog: show,
			isManufacturer: true
		});
	}

	handleSetIsVisibleAuthorizationHolderListDialog = (show) => {
		this.setState({
			isVisibleManufacturerDialog: show,
			isManufacturer: false
		});
	}

	removeAuthorizationHolderClick = () => {
		let medicine = { ...this.state.medicine };
		medicine.authorisationHolderId = undefined;

		this.setState({
			medicine: medicine,
			selectedAuthorisationHolderName: ''
		});
	}

	removeManufactorerClick = () => {
		let medicine = { ...this.state.medicine };
		medicine.manufacturerId = undefined;

		this.setState({
			medicine: medicine,
			selectedManufacturerName: ''
		});
	}

	handleAddManufacturerButton = (manufactorer: ManufacturerAdminModel) => {
		let medicine = { ...this.state.medicine }
		if (this.state.isManufacturer) {
			medicine.manufacturerId = manufactorer.manufacturerId;
			this.setState({ medicine: medicine, selectedManufacturerName: this.getManufacturerName(manufactorer) });
		}
		else {
			medicine.authorisationHolderId = manufactorer.manufacturerId
			this.setState({ medicine: medicine, selectedAuthorisationHolderName: this.getManufacturerName(manufactorer) });
		}

		this.handleSetIsVisibleManufactorerListDialog(false);
	}

	getManufacturerName = (manufacturer: ManufacturerAdminModel) => {
		if (manufacturer && manufacturer.manufacturerContent && manufacturer.manufacturerContent.length > 0) {
			let found = manufacturer.manufacturerContent.map(r => r.name);
			return found ? found.join(' / ') : '';
		}
		return '';
	}

	handleManufacturerCancelButton = () => {
		this.handleSetIsVisibleManufactorerListDialog(false);
	}

	public render() {

		const { medicine, imageUrl, selectedLangId } = this.state;

		let header = 'Medicine ' +
			(medicine.brandName ? ' -' : '') +
			(medicine.brandName ? ' ' + medicine.brandName : '') +
			(medicine.additionalTitle ? ' ' + medicine.additionalTitle : '');

		return (
			<>
				<Dialog header={header} responsive={true} width="80%"
					modal={true}
					visible={this.props.isVisible}
					onHide={this.handleCanselButton}
					footer={
						<div>
							<Button label="Save" icon="pi pi-save" onClick={(e) => this.handleSaveButton(e, false)} className="p-button-raised" />
							<Button label="Save & Close" icon="pi pi-check" onClick={(e) => this.handleSaveButton(e, true)} className="p-button-success p-button-raised" />
							<Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
						</div>}
				>
					<div style={{ minHeight: '650px', maxHeight: '700px', overflowY: 'auto' }}>

						{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
						<div style={{ maxWidth: 70 }}>
							<Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
						</div>
						<TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
							<TabPanel header="Basic info">
								<div className="p-grid p-fluid p-md-12">
									<MedicineTabBasicInfo
										handleChange={this.handleChange}
										medicine={medicine}
										setIsVisibleActiveIngredientDialog={this.handleSetIsVisibleActiveIngredientDialog}
										setIsVisibleInactiveIngredientDialog={this.handleSetIsVisibleInactiveIngredientDialog}
										removeActiveIngredientClick={(activeIngredientId) => this.removeActiveIngredientClick(activeIngredientId)}
										removeInactiveIngredientClick={(inactiveIngredientId) => this.removeInactiveIngredientClick(inactiveIngredientId)}
										setIsVisibleATCCodeListDialog={this.handleSetIsVisibleATCCodeListDialog}
										removeATCCodeClick={this.handleATCCodeRemoveClick}
										changeQuantity={this.handleQuantityChange}
										handleContentChange={this.handleContentChange}
										getContentValue={this.getMedicineValueContent}
										manufactorerName={this.state.selectedManufacturerName}
										authorisationHolderName={this.state.selectedAuthorisationHolderName}
										setIsVisibleManufactorerListDialog={this.handleSetIsVisibleManufactorerListDialog}
										setIsVisibleAuthorizationHolderListDialog={this.handleSetIsVisibleAuthorizationHolderListDialog}
										removeAuthorizationHolderClick={this.removeAuthorizationHolderClick}
										removeManufactorerClick={this.removeManufactorerClick}
									/>
								</div>
							</TabPanel>
							<TabPanel header="Overview">
								<MedicineTabOverview
									handleChange={this.handleOverviewContentChange}
									medicine={medicine}
									getContent={this.getMedicineOverviewValueContent}
								/>
							</TabPanel>
							<TabPanel header="Interactions">
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>Interactions:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithInteractionContent}
											onChange={(e) => this.handleSetIsWithInteractionContent(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithInteractionContent
										?
										<MedicineTabInteractionsContent
											handleChange={this.handleInteractionsContentChange}
											medicine={medicine}
											selectedLangId={selectedLangId}
											getContent={this.getMedicineInteractionValueContent}
										/>
										: null
									}
								</div>
							</TabPanel>
							<TabPanel header="Side Effects">
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>Medicine side effects:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithSideEffects}
											onChange={(e) => this.handleSetIsWithSideEffects(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithSideEffects
										?
										<MedicineTabSideEffects
											medicine={medicine}
											handleChange={this.handleSideEffectChange}
											onAddEditSideEffectReactionClick={this.handleCurrentSideEffectReaction}
											setIsVisibleSideEffectReactionAddEditDialog={this.handleSetIsVisibleSideEffectReactionDialog}
											setIsAnatomicalSystemDropdownDisabled={this.handleSetIsAnatomicalSystemDropdownDisabled}
											getContentValue={this.getSideEffectValueContent}
											removeSideEffectReactionClick={(ingredientSideEffectReactionId) => this.removeSideEffectReactionClick(ingredientSideEffectReactionId)}
										/>
										: null
									}
								</div>
							</TabPanel>
							<TabPanel header="Dosage">
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>Medicine dosage:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithDosageContent}
											onChange={(e) => this.handleSetIsWithDosageContent(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithDosageContent
										?
										<MedicineTabDosage
											medicine={medicine}
											handleChange={this.handleDosageContentChange}
											onAddEditDosageLevelClick={this.handleCurrentDosageLevel}
											setIsVisibleDosageLevelAddEditDialog={this.handleSetIsVisibleDosageLevelAddEditDialog}
											removeDosageLevelClick={(dosageLevelId) => this.removeDosageLevelClick(dosageLevelId)}
											getContentValue={this.getDosageContentValueContent}
										/>
										: null
									}
								</div>
							</TabPanel>
							<TabPanel header="Pregnancy">
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>Pregnancy and Breastfeeding:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithPregnancy}
											onChange={(e) => this.handleSetIsWithPregnancy(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithPregnancy
										?
										<MedicineTabPregnancy
											handleChange={this.handlePregnancyChange}
											medicine={medicine}
											selectedLangId={selectedLangId}
											getValue={this.getPregnancyValueContent}
										/>
										: null
									}
								</div>
							</TabPanel>
							<TabPanel header={Translate("Driving / Machine")}>
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>{Translate("Driving / Machine")}:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithDriveAndMachine}
											onChange={(e) => this.handleSetIsWithDriveAndMachine(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithDriveAndMachine
										?
										<MedicineTabDriveMachine
											handleChange={this.handleDriveMachineChange}
											medicine={medicine}
											selectedLangId={selectedLangId}
											getValue={this.getDriveAndMachineValueContent}
										/>
										: null
									}
								</div>
							</TabPanel>


							<TabPanel header="Safety Data">
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>{Translate("SafetyData")}:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithSafetyData}
											onChange={(e) => this.handleSetIsWithSafetyData(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithSafetyData
										?
										<MedicineTabSafetyData
											handleChange={this.handleSafetyDataChange}
											medicine={medicine}
											selectedLangId={selectedLangId}
											getSafetyDataValueContent={this.getSafetyDataValueContent}
										/>
										: null
									}
								</div>
							</TabPanel>
							<TabPanel header="Professional">
								<div className="p-grid p-fluid p-md-12">
									<MedicineTabProfessional
										handleChange={this.handleSpecificationChange}
										medicine={medicine}
										addImageClick={this.handleAddImage}
										removeImageClick={this.handleRemoveImage}
										toggleImageClick={this.handleToggleImage}
										handleContentChange={this.handleSpecificationContentChange}
										getContentValue={this.getSpecificationValueContent}
									/>
								</div>
							</TabPanel>
							<TabPanel header="Leaflet">
								<div className="p-grid p-fluid p-md-12">
									<MedicineTabLeaflet
										handleChange={this.handleChange}
										medicine={medicine}
										addLeafletClick={this.handleAddLeaflet}
										removeLeafletClick={this.handleRemoveLeaflet}
										leafletTypeChange={this.handleLeafletTypeChange}
										selectedLangId={this.state.selectedLangId}
									/>
								</div>
							</TabPanel>
						</TabView>
					</div>
				</Dialog >

				{this.state.isVisibleManufacturerDialog ? (
					<ManufactorerListDialogComponent
						selectedManufactorerId={this.state.isManufacturer ? medicine.manufacturerId : medicine.authorisationHolderId}
						isVisible={this.state.isVisibleManufacturerDialog}
						addClick={this.handleAddManufacturerButton}
						cancelClick={this.handleManufacturerCancelButton}
					/>
				)
					: null}

				{this.state.isVisibleATCCodeListDialog ? (
					<AtcCodeListDialog
						selectedATCCode={this.state.medicine.atcCode}
						addClick={this.handleATCCodeAddButton}
						cancelClick={this.handleATCCodeCancelButton}
						isVisible={this.state.isVisibleATCCodeListDialog}
					/>
				) : null}

				{this.state.isVisibleActiveIngredientDialog ? (
					<ActiveingredientListDialog
						okClick={this.handleActiveingredientAddButton}
						cancelClick={this.handleActiveIngredientCancelButton}
						isVisible={this.state.isVisibleActiveIngredientDialog}
					/>
				) : null}

				{this.state.isVisibleInactiveIngredientDialog ? (
					<InactiveingredientListDialog
						okClick={this.handleInactiveingredientAddButton}
						cancelClick={this.handleInactiveIngredientCancelButton}
						isVisible={this.state.isVisibleInactiveIngredientDialog}
					/>
				) : null}

				{this.state.isVisibleSideEffectReactionAddEditDialog ? (
					<SideEffectReactionAddEditDialog
						currentSideEffectReaction={this.state.currentSideEffectReaction}
						okClick={this.handleSideEffectReactionAddButton}
						cancelClick={this.handleSideEffectCancelButton}
						isVisible={this.state.isVisibleSideEffectReactionAddEditDialog}
						isAnatomicalSystemDropdownDisabled={this.state.isAnatomicalSystemDropdownDisabled}
						selectedLangId={this.state.selectedLangId}
					/>
				) : null}

				{this.state.isVisibleDosageLevelAddEditDialog ? (
					<DosageLevelAddEditDialog
						selectedLangId={this.state.selectedLangId}
						currentDosageLevel={this.state.currentDosageLevel}
						okClick={this.handleDosageLevelAddButton}
						cancelClick={this.handleDosageLevelCancelButton}
						isVisible={this.state.isVisibleDosageLevelAddEditDialog}
					/>
				) : null}

				<OverlayPanel ref={(el) => this.op = el} dismissable={true}>
					<img src={imageUrl} />
				</OverlayPanel>

			</>
		)
	}
}

export default MedicineAddEditDialog;

enum TabIndexes {
	BasicInfo = 0,
	Overview = 1,
	SideEffect = 2,
	Dosage = 3,
	Pregnancy = 4,
	Driving = 5,
	SafetyData = 6,
	Professional = 7,
	Leaflet = 8,
	NonExisting = 100
}